import SHARED_META from './shared'
import { SHARED_META_ZAVA } from './zava.shared'

export default {
  en_GB: {
    title: 'Log into your patient account - ZAVA',
    meta: [
      ...SHARED_META,
      ...SHARED_META_ZAVA,
      {
        property: 'og:title',
        content: 'Log into your patient account - ZAVA'
      },
      {
        property: 'og:description',
        content: 'ZAVA is an Online Doctor providing convenient online medical assessment and fast delivery of prescription treatments, without needing to see a doctor face-to-face.'
      },
      {
        property: 'og:url',
        content: 'https://www.zavamed.com/uk/'
      },
      {
        property: 'og:image',
        content: 'https://www.zavamed.com/uk/assets/images/social/zava_blue.jpg'
      },
      {
        name: 'twitter:title',
        content: 'Log into your patient account - ZAVA'
      },
      {
        name: 'twitter:description',
        content: 'ZAVA is an Online Doctor providing convenient online medical assessment and fast delivery of prescription treatments, without needing to see a doctor face-to-face.'
      },
      {
        name: 'twitter:image',
        content: 'https://www.zavamed.com/uk/assets/images/social/zava_blue.jpg'
      },
      {
        name: 'msapplication-TileImage',
        content: 'https://www.zavamed.com/uk/assets/dist/images/favicons/zava/ms-icon-144x144.png'
      }
    ],
    link: [
      {
        rel: 'apple-touch-icon',
        sizes: '57x57',
        href: 'https://www.zavamed.com/uk/assets/dist/images/favicons/zava/apple-icon-57x57.png'
      },
      {
        rel: 'apple-touch-icon',
        sizes: '60x60',
        href: 'https://www.zavamed.com/uk/assets/dist/images/favicons/zava/apple-icon-60x60.png'
      },
      {
        rel: 'apple-touch-icon',
        sizes: '72x72',
        href: 'https://www.zavamed.com/uk/assets/dist/images/favicons/zava/apple-icon-72x72.png'
      },
      {
        rel: 'apple-touch-icon',
        sizes: '76x76',
        href: 'https://www.zavamed.com/uk/assets/dist/images/favicons/zava/apple-icon-76x76.png'
      },
      {
        rel: 'apple-touch-icon',
        sizes: '114x114',
        href: 'https://www.zavamed.com/uk/assets/dist/images/favicons/zava/apple-icon-114x114.png'
      },
      {
        rel: 'apple-touch-icon',
        sizes: '120x120',
        href: 'https://www.zavamed.com/uk/assets/dist/images/favicons/zava/apple-icon-120x120.png'
      },
      {
        rel: 'apple-touch-icon',
        sizes: '144x144',
        href: 'https://www.zavamed.com/uk/assets/dist/images/favicons/zava/apple-icon-144x144.png'
      },
      {
        rel: 'apple-touch-icon',
        sizes: '152x152',
        href: 'https://www.zavamed.com/uk/assets/dist/images/favicons/zava/apple-icon-152x152.png'
      },
      {
        rel: 'apple-touch-icon',
        sizes: '180x180',
        href: 'https://www.zavamed.com/uk/assets/dist/images/favicons/zava/apple-icon-180x180.png'
      },
      {
        rel: 'icon',
        type: 'image/png',
        sizes: '192x192',
        href: 'https://www.zavamed.com/uk/assets/dist/images/favicons/zava/android-icon-192x192.png'
      },
      {
        rel: 'icon',
        type: 'image/png',
        sizes: '32x32',
        href: 'https://www.zavamed.com/uk/assets/dist/images/favicons/zava/favicon-32x32.png'
      },
      {
        rel: 'icon',
        type: 'image/png',
        sizes: '96x96',
        href: 'https://www.zavamed.com/uk/assets/dist/images/favicons/zava/favicon-96x96.png'
      },
      {
        rel: 'icon',
        type: 'image/png',
        sizes: '16x16',
        href: 'https://www.zavamed.com/uk/assets/dist/images/favicons/zava/favicon-16x16.png'
      }
    ]
  }
}
